import Regret from '../../../commons/regret';
import withTracker from '../../../commons/with-tracker';

export default withTracker(Regret);
